import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, unref as _unref, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/information-icon.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-8419d65c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-sm-12" }
const _hoisted_3 = {
  key: 0,
  class: "col-md-5"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Develop", -1))
const _hoisted_5 = { class: "table" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "col-md-10"
    }, "Filter by"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "col-md-2"
    }, "Count")
  ])
], -1))
const _hoisted_7 = { class: "col-sm-12 content-column" }
const _hoisted_8 = { class: "table table-hover" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Name", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Role", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Last login", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Teams", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Solo", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Viewpoints", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Develop", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Licence", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "col-sm-2" }, "Team Pathways", -1))
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_21 = { key: 0 }
const _hoisted_22 = ["href"]
const _hoisted_23 = { class: "btn-group" }
const _hoisted_24 = { class: "dropdown-menu" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = ["onClick"]
const _hoisted_27 = ["onClick"]
const _hoisted_28 = ["data-sort"]
const _hoisted_29 = ["href"]
const _hoisted_30 = { key: 0 }
const _hoisted_31 = ["href"]
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { key: 0 }
const _hoisted_34 = { key: 1 }
const _hoisted_35 = { key: 0 }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_37 = { key: 0 }
const _hoisted_38 = {
  key: 0,
  class: "text-uppercase",
  style: {"color":"red","font-weight":"bold"}
}
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-uppercase" }, "Open Access", -1))
const _hoisted_41 = ["onClick"]
const _hoisted_42 = { key: 1 }
const _hoisted_43 = ["onClick"]
const _hoisted_44 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_45 = {
  class: "col-sm-2",
  "data-test": "pathway-table-data"
}
const _hoisted_46 = {
  key: 0,
  style: {"text-decoration":"underline","margin-bottom":"0"}
}
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "team info",
  style: {"width":"15px","height":"15px","display":"inline","margin":"0 0 5px 5px"}
}, null, -1))
const _hoisted_48 = {
  key: 0,
  style: {"text-decoration":"underline","margin-bottom":"0"}
}
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "team info",
  style: {"width":"15px","height":"15px","display":"inline","margin":"0 0 5px 5px"}
}, null, -1))
const _hoisted_50 = { key: 0 }
const _hoisted_51 = ["onClick"]
const _hoisted_52 = { key: 1 }
const _hoisted_53 = { class: "btn-group" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-default btn-sm btn-link dropdown-toggle",
  "data-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-sm glyphicon glyphicon-option-vertical" })
], -1))
const _hoisted_55 = { class: "dropdown-menu" }
const _hoisted_56 = ["onClick"]

import { computed, ref } from "vue";
import axios from "axios";
import moment from "dayjs";
import { Tooltip } from "uiv";
import AssignLicenceDialog from "./assign-licence-dialog.vue";
import OrganisationMemberAddDialog from "./organisation-member-add-dialog.vue";
import OrganisationMemberRemovalDialog from "./organisation-member-removal-dialog.vue";
import TeamMemberPathway from "../../group-member-table/team-member-pathway.vue";
import type {
  DevelopStrengthProgressApiModel,
  GroupAndMembersApiModel,
  OrganisationAndMembersApiModel,
  OrganisationMemberApiModel,
  OrganisationMemberApiRole,
  OrganisationMemberUpdateApiModel,
  TeamMemberCompletedPathwayStepApiModel,
} from "../../../api-models";

const LAST_DAY = 25;


export default /*#__PURE__*/_defineComponent({
  __name: 'organisation-details',
  props: {
    model: {},
    sortedMembers: {},
    appliedFilter: {}
  },
  emits: ["revalidate-org-data"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

// template refs
const memberAddDialog = ref<InstanceType<typeof OrganisationMemberAddDialog> | null>(null);
const memberRemovalDialog = ref<InstanceType<typeof OrganisationMemberRemovalDialog> | null>(null);

const saveInProgress = ref(false);
const internalFilter = ref<string | null>(null);
const displayAssignLicenceModal = ref(false);
const selectedMemberId = ref<string | null>(null);
const licenceError = ref({ memberId: "", errorMessage: "" });

function valueExists(str: string | null | undefined): boolean {
  return str !== null && str !== undefined;
}

const plansStarted = computed((): DevelopStrengthProgressApiModel[] => {
  const allPlans: DevelopStrengthProgressApiModel[] = [];
  props.model?.members.forEach((x) => {
    const str = x.development?.currentStrengthProgress?.strengthItemId;
    if (valueExists(str)) {
      allPlans.push(x.development.currentStrengthProgress);
    }
    x.development?.otherProgress?.forEach((strength) => {
      if (valueExists(strength.strengthItemId)) {
        allPlans.push(strength);
      }
    });
  });
  return allPlans;
});

const plansCompleted = computed((): DevelopStrengthProgressApiModel[] => {
  return plansStarted.value.filter((plan) => plan.lastDayIndex === LAST_DAY);
});

const membersWithCompletedPlans = computed((): OrganisationMemberApiModel[] => {
  return props.sortedMembers.filter(
    (member) =>
      member.development.currentStrengthProgress.lastDayIndex === LAST_DAY ||
      member.development.otherProgress.some((p) => p.lastDayIndex === LAST_DAY),
  );
});

function peopleWithDevW(week: number): OrganisationMemberApiModel[] {
  return (
    props.model.members.filter(
      (x) =>
        x.development.currentStrengthProgress &&
        x.development.currentStrengthProgress.lastDayIndex > (week - 1) * 5 &&
        x.development.currentStrengthProgress.lastDayIndex <= week * 5,
    ) ?? []
  );
}

const filteredMembers = computed((): OrganisationMemberApiModel[] => {
  if (!internalFilter.value) return props.sortedMembers ?? [];
  if (internalFilter.value === "completed") return membersWithCompletedPlans.value;
  const week = parseInt(internalFilter.value.replace("develop", ""), 10);
  return peopleWithDevW(week);
});

function teamsMemberOf(member: OrganisationMemberApiModel): GroupAndMembersApiModel[] {
  return (
    props.model?.teams.filter((x) => x.members.find((m) => m.id === member.shortUserDetails.id)) ??
    []
  );
}

function getTeamName(
  pathway: TeamMemberCompletedPathwayStepApiModel,
  member: OrganisationMemberApiModel,
): string {
  const { teamId } = pathway;
  const relevantTeam = teamsMemberOf(member).find((team) => {
    return team.group.id === teamId;
  });
  return relevantTeam?.group.name ?? "";
}

function displayDate(dateString?: string): string {
  return dateString ? moment(dateString).format("DD/MM/YYYY") : "";
}

function getSortableDate(dateString?: string): string {
  return dateString ? moment(dateString).toISOString() : "";
}

function fontweight(lastDay: number): string {
  return lastDay === LAST_DAY ? "font-weight:bold" : "font-weight:normal";
}

function hasFilter(filter: string): boolean | undefined {
  return props.appliedFilter?.startsWith(filter);
}

function getMemberById(id: string): OrganisationMemberApiModel | undefined {
  return props.model.members.find((x) => x.shortUserDetails.id === id);
}

function toggleAssignLicenceModal(): void {
  displayAssignLicenceModal.value = !displayAssignLicenceModal.value;
}

async function removeLicenceForMember(id: string): Promise<void> {
  saveInProgress.value = true;

  const member = getMemberById(id);

  const licenceToRemoveId = member?.licence?.id;

  if (licenceToRemoveId === undefined) {
    saveInProgress.value = false;
    return;
  }

  const response = await axios.delete(`/api/admin/removelicence/${licenceToRemoveId}`);
  if (response.status === 200) {
    emit("revalidate-org-data");
  }
  saveInProgress.value = false;
}

async function assignLicenceForMember(id: string): Promise<void> {
  selectedMemberId.value = id;
  toggleAssignLicenceModal();
}

function changeRole(member: OrganisationMemberApiModel, newRole: OrganisationMemberApiRole): void {
  if (member.role === newRole) {
    return;
  }

  saveInProgress.value = true;
  axios
    .post(
      "/api/organisationmember/",
      {
        userId: member.shortUserDetails.id,
        organisationId: props.model.id,
        role: newRole,
      } as OrganisationMemberUpdateApiModel,
      {
        headers: { "content-type": "application/json" },
      },
    )
    .then(() => {
      saveInProgress.value = false;
      member.role = newRole;
    })
    .catch(() => {
      // eslint-disable-next-line no-alert
      alert("There was a problem changing the role, please try again.");
      saveInProgress.value = false;
    });
}

function removeMember(member: OrganisationMemberApiModel): void {
  memberRemovalDialog.value?.open(member, props.model).finally(() => {
    memberRemovalDialog.value?.close();
  });
}

function addMembers(): void {
  memberAddDialog.value?.open(props.model).finally(() => {
    memberAddDialog.value?.close();
  });
}

function toggleFilter(filter: string | null): void {
  internalFilter.value = internalFilter.value === filter ? null : filter;
}

function openDetailsNewTab(href: string): void {
  const newTab = window.open(href, "_blank");
  if (newTab) {
    newTab.opener = null;
  }
}

function updateLicences(): void {
  emit("revalidate-org-data");
}

return (_ctx: any,_cache: any) => {
  const _directive_data_table = _resolveDirective("data-table")!

  return (_ctx.sortedMembers)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["organisation-details container", { updating: saveInProgress.value }])
      }, [
        _createVNode(OrganisationMemberAddDialog, {
          ref_key: "memberAddDialog",
          ref: memberAddDialog
        }, null, 512),
        _createVNode(OrganisationMemberRemovalDialog, {
          ref_key: "memberRemovalDialog",
          ref: memberRemovalDialog
        }, null, 512),
        (selectedMemberId.value)
          ? (_openBlock(), _createBlock(AssignLicenceDialog, {
              key: 0,
              modelValue: displayAssignLicenceModal.value,
              memberId: selectedMemberId.value,
              onToggleAssignLicenceModal: toggleAssignLicenceModal,
              onUpdateLicences: updateLicences
            }, null, 8, ["modelValue", "memberId"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (hasFilter('plans'))
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _hoisted_4,
                  _createElementVNode("table", _hoisted_5, [
                    _hoisted_6,
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", null, [
                          _createElementVNode("a", {
                            href: "javascript:void(0)",
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleFilter(null)))
                          }, "Develop plans started(including completed)")
                        ]),
                        _createElementVNode("td", null, _toDisplayString(plansStarted.value.length), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", null, [
                          _createElementVNode("a", {
                            href: "javascript:void(0)",
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (toggleFilter('completed')))
                          }, " Develop plans completed")
                        ]),
                        _createElementVNode("td", null, _toDisplayString(plansCompleted.value.length), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", null, [
                          _createElementVNode("a", {
                            href: "javascript:void(0)",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (toggleFilter('develop1')))
                          }, " Members on Develop Week 1")
                        ]),
                        _createElementVNode("td", null, _toDisplayString(peopleWithDevW(1).length), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", null, [
                          _createElementVNode("a", {
                            href: "javascript:void(0)",
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (toggleFilter('develop2')))
                          }, " Members on Develop Week 2")
                        ]),
                        _createElementVNode("td", null, _toDisplayString(peopleWithDevW(2).length), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", null, [
                          _createElementVNode("a", {
                            href: "javascript:void(0)",
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (toggleFilter('develop3')))
                          }, " Members on Develop Week 3")
                        ]),
                        _createElementVNode("td", null, _toDisplayString(peopleWithDevW(3).length), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", null, [
                          _createElementVNode("a", {
                            href: "javascript:void(0)",
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (toggleFilter('develop4')))
                          }, " Members on Develop Week 4")
                        ]),
                        _createElementVNode("td", null, _toDisplayString(peopleWithDevW(4).length), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", null, [
                          _createElementVNode("a", {
                            href: "javascript:void(0)",
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (toggleFilter('develop5')))
                          }, " Members on Develop Week 5")
                        ]),
                        _createElementVNode("td", null, _toDisplayString(peopleWithDevW(5).length), 1)
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("h3", null, [
                _createElementVNode("button", {
                  onClick: addMembers,
                  class: "btn btn-sm btn-primary pull-right",
                  style: {"margin":"0 0 10px 20px"},
                  type: "button"
                }, " Include members... ")
              ]),
              _withDirectives((_openBlock(), _createElementBlock("table", _hoisted_8, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _hoisted_9,
                    _hoisted_10,
                    _hoisted_11,
                    _hoisted_12,
                    _hoisted_13,
                    _hoisted_14,
                    _hoisted_15,
                    _hoisted_16,
                    _hoisted_17,
                    (_ctx.appliedFilter && _ctx.appliedFilter === 'teq')
                      ? (_openBlock(), _createElementBlock("th", _hoisted_18, "TEQs"))
                      : (_openBlock(), _createElementBlock("th", _hoisted_19)),
                    _hoisted_20
                  ])
                ]),
                (filteredMembers.value.length > 0)
                  ? (_openBlock(), _createElementBlock("tbody", _hoisted_21, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredMembers.value, (member) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: member.shortUserDetails.id,
                          "data-test": "member-table-row"
                        }, [
                          _createElementVNode("td", null, [
                            _createElementVNode("a", {
                              href: '/admin/user/details/' + member.shortUserDetails.id
                            }, _toDisplayString(member.shortUserDetails.firstName) + " " + _toDisplayString(member.shortUserDetails.lastName), 9, _hoisted_22)
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("div", _hoisted_23, [
                              _createElementVNode("button", {
                                type: "button",
                                class: _normalizeClass(["btn btn-default btn-sm dropdown-toggle", { 'btn-primary': member.role === 'Admin' }]),
                                "data-toggle": "dropdown",
                                "aria-haspopup": "true",
                                "aria-expanded": "false"
                              }, _toDisplayString(member.role), 3),
                              _createElementVNode("ul", _hoisted_24, [
                                _createElementVNode("li", null, [
                                  _createElementVNode("a", {
                                    href: "javascript:void(0)",
                                    onClick: ($event: any) => (changeRole(member, 'Admin'))
                                  }, [
                                    _createElementVNode("span", {
                                      class: _normalizeClass([{ invisible: member.role !== 'Admin' }, "text-sm glyphicon glyphicon-ok"])
                                    }, null, 2),
                                    _createTextVNode("  Admin")
                                  ], 8, _hoisted_25)
                                ]),
                                _createElementVNode("li", null, [
                                  _createElementVNode("a", {
                                    href: "javascript:void(0)",
                                    onClick: ($event: any) => (changeRole(member, 'Member'))
                                  }, [
                                    _createElementVNode("span", {
                                      class: _normalizeClass([{ invisible: member.role !== 'Member' }, "text-sm glyphicon glyphicon-ok"])
                                    }, null, 2),
                                    _createTextVNode("  Member")
                                  ], 8, _hoisted_26)
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("td", null, _toDisplayString(member.shortUserDetails.lastLoggedIn), 1),
                          _createElementVNode("td", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(teamsMemberOf(member), (team) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: team.group.id,
                                "data-test": "team-button"
                              }, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "btn btn-default btn-sm",
                                  onClick: ($event: any) => (openDetailsNewTab(`/admin/group/details/${team.group.id}`))
                                }, _toDisplayString(team.group.name), 9, _hoisted_27)
                              ]))
                            }), 128))
                          ]),
                          _createElementVNode("td", {
                            "data-sort": member.solo?.completedDate ? getSortableDate(member.solo.completedDate) : ''
                          }, [
                            (member.solo)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  href: `/soloreport/view/${member.solo.id}`
                                }, _toDisplayString(displayDate(member.solo.completedDate)), 9, _hoisted_29))
                              : _createCommentVNode("", true)
                          ], 8, _hoisted_28),
                          _createElementVNode("td", null, [
                            (member.viewpoints)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                  _createElementVNode("a", {
                                    href: `/viewpoints/view/${member.shortUserDetails.id}`
                                  }, _toDisplayString(member.viewpoints.length) + " Respondents", 9, _hoisted_31)
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("td", null, [
                            (member.development.currentStrengthProgress)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                  _createTextVNode(_toDisplayString(member.development.currentStrengthProgress.strengthItemDisplayTitle) + ": Day " + _toDisplayString(member.development.currentStrengthProgress.lastDayIndex) + " ", 1),
                                  (member.development.currentStrengthProgress.lastReadActionTime)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_33, " - " + _toDisplayString(displayDate(member.development.currentStrengthProgress.lastReadActionTime)), 1))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true),
                            (hasFilter('plans'))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(member.development.otherProgress, (otherProgress, index) => {
                                    return (_openBlock(), _createElementBlock("div", { key: index }, [
                                      _createElementVNode("span", {
                                        style: _normalizeStyle(fontweight(otherProgress.lastDayIndex))
                                      }, _toDisplayString(otherProgress.strengthItemDisplayTitle) + ": Day " + _toDisplayString(otherProgress.lastDayIndex), 5),
                                      (otherProgress.lastReadActionTime)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_35, " - " + _toDisplayString(displayDate(otherProgress.lastReadActionTime)), 1))
                                        : _createCommentVNode("", true),
                                      _hoisted_36
                                    ]))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("td", null, [
                            (!!member.licence)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                  _createElementVNode("p", null, [
                                    (!member.licence?.isActive)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_38, [
                                          _createTextVNode("Cancelled "),
                                          _hoisted_39
                                        ]))
                                      : _createCommentVNode("", true),
                                    _hoisted_40
                                  ]),
                                  _createElementVNode("button", {
                                    class: "btn btn-default",
                                    onClick: ($event: any) => (removeLicenceForMember(member.shortUserDetails.id)),
                                    "data-test": "remove-licence-button",
                                    type: "button"
                                  }, " Remove licence ", 8, _hoisted_41)
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                  _createElementVNode("button", {
                                    class: "btn btn-primary",
                                    onClick: ($event: any) => (assignLicenceForMember(member.shortUserDetails.id)),
                                    "data-test": "assign-licence-button",
                                    type: "button"
                                  }, " Assign licence ", 8, _hoisted_43),
                                  (licenceError.value.memberId === member.shortUserDetails.id)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_44, _toDisplayString(licenceError.value.errorMessage), 1))
                                    : _createCommentVNode("", true)
                                ]))
                          ]),
                          _createElementVNode("td", _hoisted_45, [
                            (member.pathways.currentPathwaysInProgress)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  (member.pathways.currentPathwaysInProgress.length > 0)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_46, " Current progress: "))
                                    : _createCommentVNode("", true),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(member.pathways.currentPathwaysInProgress, (currentPathways, index) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: currentPathways.cmsStepUid + index,
                                      style: {"display":"flex","align-items":"center"},
                                      "data-test": "current-pathway-data"
                                    }, [
                                      _createVNode(TeamMemberPathway, { model: currentPathways }, null, 8, ["model"]),
                                      (teamsMemberOf(member).length > 1)
                                        ? (_openBlock(), _createBlock(_unref(Tooltip), {
                                            key: 0,
                                            text: getTeamName(currentPathways, member),
                                            enterable: false,
                                            tabindex: "0",
                                            "data-test": "team-pathway-tooltip"
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_47
                                            ]),
                                            _: 2
                                          }, 1032, ["text"]))
                                        : _createCommentVNode("", true)
                                    ]))
                                  }), 128))
                                ], 64))
                              : _createCommentVNode("", true),
                            (hasFilter('pathways') && member.pathways.otherProgress)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  (member.pathways.otherProgress.length > 0)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_48, " Other progress: "))
                                    : _createCommentVNode("", true),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(member.pathways.otherProgress, (otherPathways, index) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: otherPathways.cmsStepUid + index,
                                      style: {"display":"flex","align-items":"center"},
                                      "data-test": "other-pathway-data"
                                    }, [
                                      _createVNode(TeamMemberPathway, { model: otherPathways }, null, 8, ["model"]),
                                      (teamsMemberOf(member).length > 1)
                                        ? (_openBlock(), _createBlock(_unref(Tooltip), {
                                            key: 0,
                                            text: getTeamName(otherPathways, member),
                                            enterable: false,
                                            tabindex: "0"
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_49
                                            ]),
                                            _: 2
                                          }, 1032, ["text"]))
                                        : _createCommentVNode("", true)
                                    ]))
                                  }), 128))
                                ], 64))
                              : _createCommentVNode("", true)
                          ]),
                          (hasFilter('teq'))
                            ? (_openBlock(), _createElementBlock("td", _hoisted_50, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(member.teqsCompleted, (teq) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: teq.team.id
                                  }, [
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "btn btn-default btn-sm",
                                      onClick: ($event: any) => (openDetailsNewTab(`/team/effectiveness/${teq.team.id}`))
                                    }, _toDisplayString(teq.team.name) + " - TEQ ", 9, _hoisted_51)
                                  ]))
                                }), 128))
                              ]))
                            : (_openBlock(), _createElementBlock("td", _hoisted_52)),
                          _createElementVNode("td", null, [
                            _createElementVNode("div", _hoisted_53, [
                              _hoisted_54,
                              _createElementVNode("ul", _hoisted_55, [
                                _createElementVNode("li", null, [
                                  _createElementVNode("a", {
                                    class: "text-danger",
                                    href: "javascript:void(0)",
                                    onClick: ($event: any) => (removeMember(member))
                                  }, "Remove from organisation...", 8, _hoisted_56)
                                ])
                              ])
                            ])
                          ])
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ])), [
                [_directive_data_table, 
              filteredMembers.value.length && {
                paging: false,
                searching: true,
                info: false,
                columnDefs: [
                  { targets: [-1, -2, -3], orderable: false },
                  { targets: [4], orderDataType: 'dom-sort' }
                ],
                order: [[0, 'asc']],
              }
            ]
              ])
            ])
          ])
        ])
      ], 2))
    : _createCommentVNode("", true)
}
}

})